(function () {
  angular.module('app.core.csv-utils').factory('csvUtils', csvUtils);

  function csvUtils($q, $window, _) {
    return {
      convertTsvToCsv,
      tsvBlobTransformer,
    };

    /////////

    /**
     * @description Method to transform tab separated data to be comma separated
     * @param {Object} data - raw TSV data
     * @returns {Promise} resolved with the CSV data
     */
    function convertTsvToCsv(data) {
      const deferred = $q.defer();
      const fileReader = new $window.FileReader();
      // We read all the data in, to convert the tab separators to commas
      fileReader.addEventListener('loadend', (e) => {
        let stringData = _.get(e, 'srcElement.result');
        stringData = _.replace(stringData, new RegExp('"\\t"', 'g'), '","');
        return deferred.resolve(stringData);
      });
      fileReader.addEventListener('error', (e) => {
        deferred.reject(e);
      });
      fileReader.readAsText(data, 'utf-8');
      return deferred.promise;
    }

    /**
     * @description Method to transform tab separated data to a blob
     * @param {Object} data - raw TSV data
     * @returns {Object} object containing blob representation of tsv
     */
    function tsvBlobTransformer(data) {
      let tsvFile;

      if (data) {
        tsvFile = new Blob([data], {type: 'text/csv;charset=utf-16le;'});
      }

      return {file: tsvFile};
    }
  }
})();
